// bao migrate skip
import Bao from "./../../../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";
import BaoDialog from "./../../../factories/bao-dialog";
class SaveChecklistDialog {
    Bao = Bao;
    Dialog: any;
    public Model: any;
    Revision: KnockoutObservable<string> = ko.observable();
    NewRevision: KnockoutObservable<string> = ko.observable<string>();
    NewRevisionDescription: KnockoutObservable<string> = ko.observable<string>("");
    constructor(data: any) {
        this.Dialog = data;
        this.Revision(data.Revision());
        this.SetNewRevision();
        this.Dialog.SaveChecklistDialog = this;
    }
    ItemCompleteCheck = () => {
        let def = $.Deferred<boolean>();
        if (Bao.Utils.String.IsNullOrWhitespace(ko.unwrap(this.NewRevision)) || Bao.Utils.String.IsNullOrWhitespace(ko.unwrap(this.NewRevisionDescription))) {
            return def.resolve(false);
        }
        return def.resolve(true);
    };
    SetNewRevision() {
        try {
            if (Bao.Utils.String.IsNullOrEmpty(this.Revision())) {
                this.NewRevision("1.0");
            }
            else {
                let oldRev = this.Revision();
                let revArray: string[];
                if (oldRev.indexOf(",") > 0) {
                    revArray = oldRev.split(",");
                }
                else if (oldRev.indexOf(".") > 0) {
                    revArray = oldRev.split(".");
                }
                let lastDigit = revArray[revArray.length - 1];
                let lastDigitNum = +lastDigit;
                lastDigitNum++;
                revArray[revArray.length - 1] = lastDigitNum.toString();
                this.NewRevision(revArray.toString().replace(",", "."));
            }
        }
        catch (e) { }
    }
}
export default SaveChecklistDialog;